import { render, staticRenderFns } from "./NetaNewView.vue?vue&type=template&id=12d297a8&scoped=true&"
import script from "./NetaNewView.vue?vue&type=script&lang=js&"
export * from "./NetaNewView.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewView.vue?vue&type=style&index=0&id=12d297a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d297a8",
  null
  
)

export default component.exports